const SSR = typeof window === 'undefined';
const isMac = !SSR && window.navigator.platform === 'MacIntel';
// MOD key gets converted from Command (MacOS) to Ctrl (other platforms)
export const MOD_KEY = isMac ? '⌘' : 'Ctrl';
export const CTRL_KEY = isMac ? '^' : 'Ctrl';
export const ALT_KEY = isMac ? '⌥' : 'Alt';
export const SHIFT_KEY = '⇧';
